import React from 'react';
import Sidebar from "./Sidebar";
import SEO from "../components/seo";

const CopperTee = () => {

  //   if (!project) return <div className="project-right">Select a project to see details.</div>;

  return (
    <>
    <SEO pageKey="copperTee" />
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n    .quote-banner {\n     background: linear-gradient(to left, #000814, #0b1234, #2d3f7a);\n      color: white;\n      padding: 20px 30px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n     /*flex-wrap: wrap;*/\n    }\n    .quote-banner h5 {\n      margin: 0;\n      font-weight: 700;\n      font-style: italic;\n    }\n    .quote-banner .btn {\n      font-weight: 600;\n      text-transform: uppercase;\n      margin: 5px;\n    }\n\n    .composition-card {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  }\n\n  .composition-header {\n    background: #0E47A1; /* dark navy (like your image) */\n    color: #fff;\n    font-weight: 700;\n    padding: 12px 20px;\n    font-size: 1rem;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ccc !important;\n    vertical-align: middle;\n  }\n\n  .table th {\n    width: 26%;\n    font-weight: 600;\n  }\n\n    .table-container {\n      background: #fff;\n      color: #000;\n      border-radius: 6px;\n      overflow: hidden;\n    }\n\n    .table {\n      margin: 0;\n      border-collapse: separate;\n      border-spacing: 0;\n      border-radius: 10px;\n      overflow: hidden;\n    }\n   .tbl_thred th{\n      background-color: #0E47A1;\n      color: #fff;\n    }\n    \n  "
        }}
      />
      <main>
        {/* breadcrumb area start */}
        <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">
          <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
            <img
              src="/static/img/shape/breadcrumn-shape.webp"
              alt=""
            />
          </div>
          <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
            <img
              src="/static/img/shape/ca-line-shape.WebP"
              alt=""
            />
          </div>
          <div className="container">
            <div className="ca-breadcrumb-content text-center">
              <h2 className="ca-breadcrumb-title fnw-600">Copper Tee</h2>
              <div className="it-breadcum-link">
                <a href="/">Home</a>
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
                <a href="/products">Products</a>
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
                <a className="active" href="#">
                  Copper Tee
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* breadcrumb area end */}
        {/* project left */}
        <div className="ca-service-lft-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mb-30">
                <div className="ca-project-content-area">
                  <div className="ca-pro-thumb-content">
                    <h2 className="ca-project-thumb-title theme-black-3 fnw-600 ca-text-cap">
                      Copper Tee
                    </h2>
                    <p className="pt-16 pb-40">
                     We manufacture and supply high-quality Copper Tee fittings designed for branch connections in HVAC, refrigeration, plumbing, and industrial piping systems. Engineered for smooth, balanced flow and reliable direction change, these tees ensure leak-proof performance and long service life even under high pressure and temperature applications.
                    </p>
                    <div className="ca-servic-thumb br-7">
                      <img
                        className="w-100"
                        src="/static/img/portfolio/Product_T.webp"
                        alt=""
                      />
                    </div>
                    <br />
                    <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                      Manufacturing Excellence and Applications
                    </h3>
                    <p className="pt-16">
                      At Karmyogi Enterprises, our Copper Tees are made from 99.9% pure copper, offering exceptional thermal conductivity, corrosion resistance, and mechanical strength. Every tee is produced with precision sizing to ensure perfect fit, smooth internal flow, and hassle-free brazing during installation.
                    </p>
                    
                    <div className="ca-about-item3 cream-bg-3 p-relative">
                      <p>
                        Copper Tees are widely used for refrigerant line splitting, bypass circuits, and liquid/gas distribution in commercial and domestic cooling systems. In plumbing installations, they provide durable connections for hot and cold water supply lines.
                      </p>
                    </div>
                    <div className="ca-ab-item-check ca-ab-item-check-2 caborder-top">
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Perfect 3-Way Connection
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Leak-Proof Brazed Joint Design
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                           Excellent Thermal Conductivity
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            High Corrosion & Pressure Resistance
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Smooth Inner Surface for Minimal Pressure Drop
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Available in Multiple Sizes and Custom Options
                          </h4>
                        </div>
                      </div>
                    </div>
                    {/* quote-banner */}
                    {/*  <div class="container my-4">
                 <div class="quote-banner">
                   <h5>GET YOUR INSTANT QUOTE NOW – FAST DELIVERY & BEST PRICE GUARANTEED!</h5>
                   <div>
                     <a href="#contact" class="btn btn-primary">Contact Us</a>
                   </div>
                 </div>
               </div>
 */}
                    <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                      Material Composition and Performance
                    </h3>
                    <p className="pt-16">
                      Manufactured with 99.9% pure copper, our tees exhibit high resistance to temperature variations, pressure fluctuations, and corrosive effects of refrigerants and liquids. The seamless design ensures unrestricted flow, preventing turbulence, vibration, and leakage.
                    </p>
                  </div>
                </div>
                {/* Chemical Composition Table */}
                   <div className="container my-4">
              <div className="composition-card">
                <div className="composition-header">
                  Chemical Composition
                </div>
                <table className="table table-bordered mb-0">
                  <thead className="tbl_thred">
                  <tr>
                    <th scope="row">Element</th>
                    <th>Percentage (%)</th>
                  </tr>
                </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Cu (Copper)</th>
                      <td>99.90%</td>
                    </tr>
                    <tr>
                      <th scope="row">P (Phosphorus)</th>
                      <td>0.015% To 0.04%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* <div className="container table-container mt-4">
               <div className="composition-header">
                  Chemical Composition
                </div>
              <table className="table table-bordered text-center align-middle table-bordered_tbl">
                <thead className="tbl_thred">
                  <tr>
                    <th>Fitting Type</th>
                    <th>Nominal Size</th>
                    <th>Outer Diameter (mm)</th>
                    <th>Wall Thickness (mm)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Copper Tee</td>
                    <td>10mm</td>
                    <td>10</td>
                    <td>0.8 – 1.0</td>
                  </tr>
                  <tr>
                      <td>Copper Tee</td>
                    <td>12mm</td>
                    <td>12</td>
                    <td>0.8 – 1.0</td>
                  </tr>
                  <tr>
                      <td>Copper Tee</td>
                    <td>15mm</td>
                    <td>15</td>
                    <td>0.9 – 1.2</td>
                  </tr>
                  <tr>
                    <td>Copper Tee</td>
                    <td>18mm</td>
                    <td>18</td>
                    <td>1.0 – 1.2</td>
                  </tr>
                  <tr>
                    <td>Copper Tee</td>
                    <td>22mm</td>
                    <td>22</td>
                    <td>1.0 – 1.5</td>
                  </tr>
                  <tr>
                     <td>Copper Tee</td>
                    <td>28mm</td>
                    <td>28</td>
                    <td>1.2 – 1.5</td>
                  </tr>
                  <tr>
                     <td>Copper Tee</td>
                    <td>As Required</td>
                    <td>As Required</td>
                    <td>Available on Request</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
          </div>
          
             {/* Sidebar */}
          <Sidebar />

            </div>
          </div>
        </div>
        <div className="ca-more-section pb-70">
          <div className="container">
            {/* <h2 class="ca-more-title theme-black-3 fnw-600 text-center mb-60">More Projects</h2>
   <div class="row">
      <div class="col-lg-4 col-md-6"> */}
            {/* single-portfolio-item */}
            {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/img/portfolio/portfolio-sm-1.4.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
            {/* single-portfolio-item */}
            {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/img/portfolio/portfolio-sm-1.5.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
            {/* single-portfolio-item */}
            {/*  <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/img/portfolio/portfolio-sm-1.6.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div> */}
            {/* </div>
   </div>
 */}
          </div>
        </div>
      </main>
    </>

  );
};

export default CopperTee;
